/**
 * Encoding for a multi-valued column filter.
 *
 * `column_filters` is a `Record<string, string>` on the wire, and changing that would touch every
 * list endpoint — so a multi-select filter packs its values into one string instead. Each value is
 * URI-escaped before joining, because a dropdown option's label may itself contain a comma and
 * SELECT filters match on the label rather than an id.
 *
 * Mirrors `decodeColumnFilterValues` in backend/src/common/utils/custom-field-list.util.ts. The two
 * must agree; a change here without one there silently drops filter values.
 */

const SEPARATOR = ',';

export const encodeColumnFilterValues = (values: string[]): string =>
  values.map((value) => encodeURIComponent(value)).join(SEPARATOR);

export const decodeColumnFilterValues = (raw: string | undefined): string[] => {
  if (!raw) return [];

  return raw
    .split(SEPARATOR)
    .map((part) => {
      try {
        return decodeURIComponent(part).trim();
      } catch {
        // A value that failed to escape is still worth showing as selected rather than vanishing
        // from the control.
        return part.trim();
      }
    })
    .filter(Boolean);
};
